module.exports = __webpack_public_path__ + "img/flag-malawi.9688a205.png";